<div class="row no-gutters mobile-width">
  <!-- navigation -->
  <aside class="col-12 col-md-3 navigation-background">
    <div class="navigation-wrapper">
    <ng-container *ngFor="let item of menuData; index as i">
      <div class="nav-block" *ngIf="item.visible" [attr.data-index]="i" [class.active]="sectionBlock === item.name">
        <a [routerLink]="" (click)="submitBlock(declarationsForm, item.path)">
          <div class="active-block"></div>
          <div class="validation-indicator" [ngClass]="{'valid': item.valid, 'uhoh': item.valid === false}">
            <span class="icon" *ngIf="item.valid != null && item.valid === false">!</span>
            <i class="fas fa-check" *ngIf="item.valid != null && item.valid"></i>
          </div>
          <div [innerHtml]="item.label || 'Confirmation'" class="block-name"></div>
        </a>
      </div>
    </ng-container>
  </div>
</aside>
<!-- /navigation -->

<!-- main container -->
<main class="col col-12 col-md-9 col-main" [@fadeAnimation]="true">
  <h1 class="section-title" [innerHtml]="declarationsTitle"></h1>
  <form [formGroup]="declarationsForm" (ngSubmit)="onSubmit(declarationsForm)">
    <br>
    <div [ngSwitch]="switchDeclarations">
    <div *ngSwitchCase="false" class="declarations-msg" id="declarationsMsg">
    <div *ngIf="!timedOut">
      <p *ngIf="!agentOnAgentDeclarations || agentOnInsuredDeclarations">Before signing your application, it is important to review your completed information to ensure it is accurate. The following forms will be included for your review:</p>
      <p *ngIf="agentOnAgentDeclarations">Before signing this application, it is important to review the completed information to ensure it is accurate. The following forms will be included for your review:</p>

      <br>
      <div class="declarations-list">
        <ul>
          <ng-container *ngFor="let question of questions">
            <li [innerHTML]="question.ToolTip" *ngIf="question.ToolTip && showConditionalQuestion(question)"></li>
          </ng-container>
        </ul>
      </div>
    </div>
      <br>
      <div *ngIf="timedOut && !agentOnAgentDeclarations">
        <p>
          We’re sorry, the system is unable to generate a PDF of your completed application forms at this time. However, you can still continue through the process by clicking on the “next” button.
        </p>
        <br>
        <p>
          On the next page, you will be asked to acknowledge your acceptance of the forms, as well as review disclosures and consents, prior to signing. You will receive a copy of the signed forms via email once your insurance agent applies their eSignature.
        </p>
        <br>
        <p>
          If you would like to review any of the information you entered before signing the application, please use the “previous” button to go back to the applicable section(s).
        </p>
      </div>
      <div *ngIf="timedOut && agentOnAgentDeclarations">
        <p>
          We’re sorry, the system is unable to generate a PDF of the completed application forms at this time. However, you can still continue through the process by clicking on the “next” button.
        </p>
        <br>
        <p>
          On the next page, you will be asked to acknowledge your acceptance of the forms, as well as review disclosures and consents, prior to signing.
        </p>
        <br>
        <p>
          If you would like to review any of the information you entered before signing the application, please use the “previous” button to go back to the applicable section(s).
        </p>
      </div>

    <div *ngIf="!agentOnInsuredDeclarations && !timedOut">
      <div *ngIf="!htmlLoaded && !agentOnAgentDeclarations || agentOnInsuredDeclarations"><p>Please note that we are currently generating a PDF of your completed application forms; this process should take 3 minutes or less. Once the forms are available, a “review my application forms” button will appear. We appreciate your patience.</p><br></div>
      <div *ngIf="!htmlLoaded && agentOnAgentDeclarations"><p>Please note that we are currently generating a PDF of the completed application forms; this process should take 3 minutes or less. Once the forms are available, a “review my application forms” button will appear. We appreciate your patience.</p><br></div>


      <div *ngIf="!htmlLoaded" class="wait-time-parent">
          <p class="text-muted header-base header-4"><span class="timer-wrapper"><div >
            <svg class="jh-hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <title>Hourglass_20px_Black</title>
              <g>
                <path d="M15.132,2.667h1.535V1H3.333V2.667H4.952V6.088L8.863,10,4.952,13.91v3.423H3.333V19H16.667V17.333H15.132V13.91L11.22,10l3.912-3.911ZM13.465,14.6v2.732H6.618V14.6l3.424-3.423ZM10.042,8.82,6.618,5.4V2.667h6.847V5.4Z"/>
                <rect x="7.523" y="14.696" width="4.921" height="1.667"/>
              </g>
            </svg>Time elapsed: {{counter}}
          </div></span></p>
      </div>

        <div *ngIf="htmlLoaded" >
          <button type="button" class="btn btn-primary"
            (click)='openPdfInWindow()'>Review my application forms</button> </div>
      </div>
      <br>
      <br>
      <div *ngIf="signatureReady || agentOnInsuredDeclarations">
        <div *ngIf="!agentOnAgentDeclarations"><p>Thank you for reviewing your completed forms. If all the information is correct, type your name at the bottom of this page to apply your eSignature to the application package. You will receive a copy of the signed forms via email once your insurance agent applies their eSignature.</p>
        </div>
        <div *ngIf="agentOnAgentDeclarations"><p>Thank you for reviewing your completed forms. If all the information is correct, type your name at the bottom of this page to apply your eSignature to the application package.</p>
        </div>
        <br>
        <p class="text-muted block">By typing my name below and clicking 'Submit; I (i) certify that I have reviewed and retained copies of the disclosures provided and (ii) hereby apply my electronic signature to the application and supplemental forms listed and included in the PDF above.</p>
      </div>
  </div>
      <div *ngSwitchCase="true" id="declarationsPn" class="declarations-wrapper">
        <!-- bulleted list loop -->
        <p>{{ signatureInstructions }} </p>
        <div class="declarations-list">
          <ul>
            <ng-container *ngFor="let question of questions">
              <li [innerHTML]="question.ToolTip" *ngIf="question.ToolTip && showConditionalQuestion(question)"></li>
            </ng-container>
          </ul>
        </div>
        <!-- Question loop -->
        <ng-container *ngFor="let question of questions">
          <div class="row">
            <div class="col-12" *ngIf="question.QuestionText && showConditionalQuestion(question)">
              <p [innerHTML]="question.ToolTip" style="text-decoration: underline;"></p>
              <p class="block"><span [innerHtml]="question.QuestionTextAlt || question.QuestionText"></span></p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- Signature  -->
    <!-- fields wrapper -->
    <div class="fields-wrapper">
      <div class="overlay" *ngIf="!isEditable"></div>
      <div class="row signature-mobile-wrapper" *ngIf="signatureReady || agentOnInsuredDeclarations">
        <div class="col-md-8 col-mobile-signature">
          <ng-container>
            <div class="form-group">
              <p>Signature {{fullNameDisplay}}<sup class="asterisk">*</sup></p>
              <input class="form-control mobile-signature-input" id="signature" [formControlName]="audience.signature" (change)="checkForComplete()">
              <!-- validation message -->
            </div>
            <error-messages [form]="declarationsForm" [field]="audience.signature"></error-messages>
          </ng-container>
          Signed at:
        </div>
        <div class="col-md-4 col-mobile-signature">
          <ng-container>
            <div class="form-group">
              <p>Date</p>
                <input class="form-control mobile-signature-input" [value]="localDate" disabled>
            </div>
          </ng-container>
        </div>
        <div class="col-md-8 col-mobile-signature">
          <ng-container>
            <div class="form-group">
              <p>City <sup class="asterisk">*</sup></p>
              <input class="form-control mobile-signature-input" id="city" [formControlName]="audience.city" (change)="checkForComplete()">
            </div>
            <error-messages [form]="declarationsForm" [field]="audience.city"></error-messages>
          </ng-container>
        </div>
        <div class="col-md-4 col-mobile-signature">
          <ng-container>
            <div class="form-group">
              <p>State <sup class="asterisk">*</sup></p>
                <div class="select-wrapper mobile-signature-input">
                  <label for="SignatureInsuredLocationState" style="display:none">State</label>
                  <select class="form-control" id="SignatureInsuredLocationState" [formControlName]="audience.state" (change)="checkForComplete()">
                    <option [ngValue]="null" label="State" disabled selected="selected"></option>
                    <option *ngFor="let opt of states" [value]="opt.key">
                      {{ opt.value }}
                    </option>
                  </select>
                </div>
                <error-messages [form]="declarationsForm" [field]="audience.state"></error-messages>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
      <div *ngIf="(insuredSignatureReminder && insuredSignatureReminder.length > 0) &&  signatureReady" class="insured-reminder" >
        <p><b>{{insuredSignatureReminder}}</b></p>
      </div>
      <div class="button-wrapper button-wrapper-next-previous text-center float-right" style="margin-top:100px">
        <button class="btn btn-prev" (click)="submitBlock(declarationsForm, 'back')" type="button"><i class="fas fa-angle-left"></i> Prev</button>
        <button *ngIf="(!checkAgentOnDeclarationPage() && !timedOut) || switchDeclarations" class="btn btn-primary btn-next" type="submit" [disabled]="disableButton">Submit <i class="fas fa-angle-right"></i></button>
        <button *ngIf="(!checkAgentOnDeclarationPage() && timedOut) && !switchDeclarations" class="btn btn-primary btn-next" (click)="switchNoPdfDeclarations()">Next <i class="fas fa-angle-right"></i></button>
        <button *ngIf="checkAgentOnDeclarationPage()" class="btn btn-primary btn-next" [disabled]="disableButton" type="submit">Next <i class="fas fa-angle-right"></i></button>
    </div>

  </form>
</main>
<!-- main container -->
</div>